import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../constants/common'
import { isFormArrayFieldsEqual } from '../../../utils/formHelpers'
import {
  FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED,
  formValidationSchemaNoChanged,
  RESPONSIBLE_MANAGERS_LIMIT,
} from '../../Form'

export function getResponsibleManagersFormValidationSchema({
  fieldName,
  initialValues,
}) {
  return Yup.object({
    [fieldName]: Yup.array()
      .of(Yup.object())
      .max(
        RESPONSIBLE_MANAGERS_LIMIT,
        FORM_ERROR_NAME_RESPONSIBLE_MANAGERS_LIMIT_EXCEEDED
      ),
  }).when(EMPTY_LIST, {
    then: schema =>
      schema.concat(
        formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormArrayFieldsEqual,
          isEqualProps: {
            name: fieldName,
          },
        })
      ),
  })
}
